var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChatMedico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3CDBC0",
    d: "M342,19.998h-86V378h5.11l82.894,110.005C345.92,490.544,348.835,492,352,492c5.514,0,10-4.486,10-10 V377.502l15.268-3.719c32.06-7.807,61.177-26.466,81.988-52.542C480.678,294.401,492,262.159,492,228v-58.002 c0-39.879-15.654-77.495-44.08-105.92C419.495,35.652,381.879,19.998,342,19.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F41",
    d: "M382,482c0,16.568-13.433,30-30,30c-9.789,0-18.483-4.691-23.959-11.945L251.139,398H170 C76.5,398,0,321.5,0,228v-58.002c0-93.5,76.5-170,170-170h172c93.5,0,170,76.5,170,170V228c0,79.734-55.633,147.106-130,165.216 V482z M342,452.113V358c34.536,0,67.131-13.574,91.778-38.222S472,262.536,472,228v-58.002c0-34.536-13.574-67.131-38.222-91.778 S376.536,39.998,342,39.998H170c-34.536,0-67.131,13.574-91.778,38.222S40,135.462,40,169.998V228 c0,34.536,13.574,67.131,38.222,91.778S135.464,358,170,358h101.082L342,452.113z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF7F41",
    points: "356,158.999 296,158.999 296,98.999 216,98.999 216,158.999 156,158.999 156,238.999 216,238.999  216,298.999 296,298.999 296,238.999 356,238.999  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatMedico);
export default __webpack_public_path__ + "static/media/icon_chat_medico.0e5e0139bd72c5ef5cb5f92c97c5cc55.svg";
export { ForwardRef as ReactComponent };